import {buttonContained} from "./ButtonContained";
import {useDispatch} from "react-redux";
import {Fragment, useRef} from "react";
import {history} from "../../../../../_helpers";
import {utilityActions} from "../../../../../_actions";
import {SnackBar} from "../../../../common";
import BasicModal from "../../../../v2/common/BasicModal.jsx";
import {Box, Link} from "@mui/material";
import Input from "../../../../v2/views/Channels/ConnectChannels/Utilities/Input";
import {basicModalStyle, modalInnerStyles} from "./basicModalStyles";

/**
 * This modal will show after the user has entered some API data into a channel setup modal,
 * we verified them and generated a webhook URL.
 * When the whole process is successful, we show this modal so the user can copy the newly generated webhook URL.
 * @param {Object} props
 * @param {boolean} props.showWebhookUrl Boolean to show the modal or not. Should come from store.
 * @param {string} props.webhookUrl
 * @param {string} props.platformUrl
 * @param {string} props.dataSourceName
 */

export default function DataSourceWebhookModal({showWebhookUrl, webhookUrl, platformUrl, dataSourceName}) {
	const {OutlineButton, SolidButton} = buttonContained;
	const dispatch = useDispatch()
	const inputRef = useRef(null)

	const closeModal = () => {
		history.push('/company/connect-channels');
	}

	const copyToClipBoard = (event, textArea) => {
		dispatch(utilityActions.copyToClipboard(event, textArea));
		SnackBar.showMessage('Copied!');
	}

	return (
		<Fragment>
			<BasicModal
				open={showWebhookUrl}
				handleClose={closeModal}
				title={`Copy Webhook URL and paste in ${dataSourceName}`}
				style={basicModalStyle}
			>
				<Box sx={styles.inputContainer}>
					<Box sx={styles.input}>
						<Input
							ref={inputRef}
							placeholder={'Webhook URL'}
							value={webhookUrl}
							multiline
							readOnly
						/>
					</Box>

					<Box sx={styles.actionButton}>
						<OutlineButton label="Copy" buttonBordered action={(event) => copyToClipBoard(event, inputRef.current)} />
					</Box>
				</Box>

				{platformUrl && (
					<Box sx={styles.bottomBar}>
						<Box sx={modalInnerStyles.description}>
							Add it <Link sx={styles.link} href={platformUrl} target='_blank' rel="noopener" underline="none">here</Link>
						</Box>

						<SolidButton label="Continue" action={closeModal} />
					</Box>
				)}
			</BasicModal>
		</Fragment>
	)
}

const styles = {
	inputContainer: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: {sm: 'center'}
	},
	input: {
		flexGrow: 1,
	},
	actionButton: {
		mt: { xs: 2, sm: 2.5 },
		ml: { xs: 0, sm: 1.5 },
	},
	bottomBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: 2.5,
	},
	link: {
		color: '#125e82',
		fontFamily: 'FustatMedium',
		':hover': {
			color: '#125e82',
			backgroundColor: 'unset'
		}
	},
}
